import {
  Component,
  input,
  output,
  viewChild,
  TemplateRef
} from '@angular/core';

import { ProfileEditFormComponent } from '@sondermind/features/account-edit';
import { IrisButtonContainerAlignments } from '@sondermind/iris/button';

@Component({
  selector: 'client-setup-basic-info',
  templateUrl: './setup-basic-info.component.html',
  styleUrls: ['./setup-basic-info.component.scss'],
  standalone: false
})
export class SetupBasicInfoComponent {
  readonly useInSessionRequest = input<boolean>(false);
  readonly isMobile = input<boolean>(false);
  readonly isProposeATime = input<boolean>(false);
  readonly fromDirectBooking = input<boolean>(false);

  readonly basicInfoSubmitted = output<void>();

  readonly profileEditForm = viewChild.required<ProfileEditFormComponent>('profileEditForm');

  // Template for the action button that parent component can render
  readonly actionButtonTemplate = viewChild.required<TemplateRef<unknown>>('actionButton');

  readonly irisButtonContainerAlignments = IrisButtonContainerAlignments;

  /**
   * Submit profile edit form, success will trigger attestation signing.
   */
  submitBasicInfo(): void {
    this.profileEditForm().submitForm();
  }

  /**
   * After basic info successfully submits,
   * emit the event to let parent know basic info step is done.
   */
  profileInfoSubmitted(): void {
    this.basicInfoSubmitted.emit();
  }

  /**
   * After attestations successfully submit, let parent know basic info step is done.
   */
  attestationsSubmitted(): void {
    this.basicInfoSubmitted.emit();
  }

  get isSubmitDisabled(): boolean {
    return !this.profileEditForm()?.profileForm?.valid || this.profileEditForm()?.submitting;
  }
}
